/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PdfConversionStatus } from './PdfConversionStatus';
import {
    PdfConversionStatusFromJSON,
    PdfConversionStatusFromJSONTyped,
    PdfConversionStatusToJSON,
    PdfConversionStatusToJSONTyped,
} from './PdfConversionStatus';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { ScreenerDocumentError } from './ScreenerDocumentError';
import {
    ScreenerDocumentErrorFromJSON,
    ScreenerDocumentErrorFromJSONTyped,
    ScreenerDocumentErrorToJSON,
    ScreenerDocumentErrorToJSONTyped,
} from './ScreenerDocumentError';
import type { ExternalEhrDocument } from './ExternalEhrDocument';
import {
    ExternalEhrDocumentFromJSON,
    ExternalEhrDocumentFromJSONTyped,
    ExternalEhrDocumentToJSON,
    ExternalEhrDocumentToJSONTyped,
} from './ExternalEhrDocument';
import type { DocumentProcessingStatus } from './DocumentProcessingStatus';
import {
    DocumentProcessingStatusFromJSON,
    DocumentProcessingStatusFromJSONTyped,
    DocumentProcessingStatusToJSON,
    DocumentProcessingStatusToJSONTyped,
} from './DocumentProcessingStatus';

/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    name: string;
    /**
     * User-facing document name. Falls back to `name` when unset; `name` stays canonical for intake logic.
     */
    display_name?: string | null;
    /**
     * 
     */
    s3_key?: string;
    /**
     * 
     */
    gcs_key?: string;
    /**
     * 
     */
    s3_access_url?: string;
    /**
     * 
     */
    processing_status?: DocumentProcessingStatus;
    /**
     * 
     */
    connector_document_id?: string;
    /**
     * 
     */
    errors?: Array<ScreenerDocumentError>;
    /**
     * Deprecated: use errors array with PROCESSING_ERROR type instead. Legacy field kept for backward compatibility.
     * @deprecated
     */
    processing_error?: string;
    /**
     * 
     */
    page_count?: number;
    /**
     * 
     */
    filesize?: number;
    /**
     * 
     */
    pdf_conversion_status?: PdfConversionStatus;
    /**
     * 
     */
    orig_s3_key?: string;
    /**
     * 
     */
    orig_content_hash?: string;
    /**
     * 
     */
    content_type?: string;
    /**
     * 
     */
    has_been_analyzed?: boolean;
    /**
     * 
     */
    metadata?: { [key: string]: any; };
    /**
     * 
     */
    created_at?: string;
    /**
     * 
     */
    is_failed_ocr?: boolean;
    /**
     * 
     */
    created_by_user?: User;
    /**
     * 
     */
    external_ehr_document?: ExternalEhrDocument;
    /**
     * 
     */
    combined_from_lead_id?: string;
}



/**
 * Check if a given object implements the Document interface.
 */
export function instanceOfDocument(value: object): value is Document {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function DocumentFromJSON(json: any): Document {
    return DocumentFromJSONTyped(json, false);
}

export function DocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Document {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'name': json['name'],
        'display_name': json['display_name'] === undefined ? undefined : json['display_name'] === null ? null : json['display_name'],
        's3_key': json['s3_key'] == null ? undefined : json['s3_key'],
        'gcs_key': json['gcs_key'] == null ? undefined : json['gcs_key'],
        's3_access_url': json['s3_access_url'] == null ? undefined : json['s3_access_url'],
        'processing_status': json['processing_status'] == null ? undefined : DocumentProcessingStatusFromJSON(json['processing_status']),
        'connector_document_id': json['connector_document_id'] == null ? undefined : json['connector_document_id'],
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(ScreenerDocumentErrorFromJSON)),
        'processing_error': json['processing_error'] == null ? undefined : json['processing_error'],
        'page_count': json['page_count'] == null ? undefined : json['page_count'],
        'filesize': json['filesize'] == null ? undefined : json['filesize'],
        'pdf_conversion_status': json['pdf_conversion_status'] == null ? undefined : PdfConversionStatusFromJSON(json['pdf_conversion_status']),
        'orig_s3_key': json['orig_s3_key'] == null ? undefined : json['orig_s3_key'],
        'orig_content_hash': json['orig_content_hash'] == null ? undefined : json['orig_content_hash'],
        'content_type': json['content_type'] == null ? undefined : json['content_type'],
        'has_been_analyzed': json['has_been_analyzed'] == null ? undefined : json['has_been_analyzed'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
        'is_failed_ocr': json['is_failed_ocr'] == null ? undefined : json['is_failed_ocr'],
        'created_by_user': json['created_by_user'] == null ? undefined : UserFromJSON(json['created_by_user']),
        'external_ehr_document': json['external_ehr_document'] == null ? undefined : ExternalEhrDocumentFromJSON(json['external_ehr_document']),
        'combined_from_lead_id': json['combined_from_lead_id'] == null ? undefined : json['combined_from_lead_id'],
    };
}

export function DocumentToJSON(json: any): Document {
    return DocumentToJSONTyped(json, false);
}

export function DocumentToJSONTyped(value?: Document | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'name': value['name'],
        'display_name': value['display_name'],
        's3_key': value['s3_key'],
        'gcs_key': value['gcs_key'],
        's3_access_url': value['s3_access_url'],
        'processing_status': DocumentProcessingStatusToJSON(value['processing_status']),
        'connector_document_id': value['connector_document_id'],
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(ScreenerDocumentErrorToJSON)),
        'processing_error': value['processing_error'],
        'page_count': value['page_count'],
        'filesize': value['filesize'],
        'pdf_conversion_status': PdfConversionStatusToJSON(value['pdf_conversion_status']),
        'orig_s3_key': value['orig_s3_key'],
        'orig_content_hash': value['orig_content_hash'],
        'content_type': value['content_type'],
        'has_been_analyzed': value['has_been_analyzed'],
        'metadata': value['metadata'],
        'created_at': value['created_at'],
        'is_failed_ocr': value['is_failed_ocr'],
        'created_by_user': UserToJSON(value['created_by_user']),
        'external_ehr_document': ExternalEhrDocumentToJSON(value['external_ehr_document']),
        'combined_from_lead_id': value['combined_from_lead_id'],
    };
}

